import styled from "@emotion/styled";
import { Typography } from "../../Typography";

export const StepTitle = styled(Typography)`
  margin-bottom: 24px;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  gap: 16px;

  @media ${({ theme }) => theme.bp.tabletDown} {
    flex-direction: column-reverse;
  }
`;
